<template>
  <div class="top-bar">
    <div class="group-action-button" >
      <v-menu offset-y >
        <template #activator="{ on: onMenu }">
          <v-tooltip bottom>
            <template #activator="{ on: onTooltip }">
              <v-btn
                min-width="45"
                style="margin-right: 10px;"
                class="mb-2"
                color="info"
                small
                v-on="{ ...onMenu, ...onTooltip }"
                v-show="actionList.length > 0"
              >
                <v-icon>mdi-gesture-tap</v-icon>
              </v-btn>
            </template>

            <span>Thao tác</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item
            v-for="(action, index) in actionList"
            :key="`${action.id}_${index}`"
            @click="showModalAction(action.type)"
          >
            <v-list-item-title>
              {{ action.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu >
    </div>
    <div>
      <v-tabs v-model="tab">
        <v-tab key="csdk" @click="changeTab(1, 0, true)" v-if="checkRole('periodic-care-tab_read')">Chăm sóc định kỳ</v-tab>
        <v-tab key="gh_us" @click="changeTab(2, 0, true)" v-if="checkRole('extend-tab_read')">Gia hạn - Upsale</v-tab>
        <v-tab key="kc" @click="changeTab(1, 1, true)" v-if="checkRole('general-tab_read')">Kho chung</v-tab>
      </v-tabs>
    </div>
    <div class="search-form">
      <v-text-field
        class="search-text-field"
        placeholder="Tìm kiếm theo Tên, SĐT, mã khách hàng"
        height="25px"
        clearable
        v-model="filterForm.mobile"
        @keyup.enter="searchRecords"
      ></v-text-field>
      <div class="group-btn-search" @click="searchRecords">
        Tìm kiếm
        <v-menu
          :internal-activator="true"
          v-model="filterForm.closeMenu"
          content-class="menu__customer no-contain overflow-visible"
          :close-on-content-click="false"
          :close-on-click="isCloseOnClick"
          style="z-index: 10"
        >
          <template v-slot:activator="menuON">
            <v-tooltip bottom style="z-index: 10;">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  medium
                  color="white"
                  v-on="on"
                  class="search-contact--dropdown"
                >
                  <v-icon size="20"
                          v-on="menuON.on"
                  >mdi-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <span>Tìm kiếm nâng cao</span>
            </v-tooltip>
          </template>
          <card-filter-form
            :filterForm.sync="filterForm"
            :listUser="listUser"
            @change-close-on-click="changeCloseOnClick"
          />
        </v-menu>
      </div>
    </div>
    <div class="d-flex">
      <v-select
        v-model="filterForm.limit"
        :items="limitOptions"
        style="width: 60px"
        @change="searchRecords"
        hide-details
        class="pt-0 mr-4"
      >
      </v-select>
      <div class="text-right mb-1 mt-2 d-flex align-center">
        <div style="width: 50px" class="d-flex align-center justify-end">
          {{ showIndex() }}
        </div>
        <v-btn
          small
          class="pagination-btn-left"
          :disabled="filterForm.page == 1"
          @click="previousPage"
        >
          <v-icon>mdi-menu-left</v-icon>
        </v-btn>
        <v-btn
          small
          class="pagination-btn-right"
          :disabled="totalItem < filterForm.limit"
          @click="nextPage"
        >
          <v-icon>mdi-menu-right</v-icon>
        </v-btn>
      </div>
      <div style="width: 35px">
        <v-text-field
          v-model="filterForm.pendingPage"
          class="pt-0"
          min="1"
          step="1"
          type="number"
          hide-details
          @input="applyPendingPage()"
        >
        </v-text-field>
      </div>
    </div>
    <ModalChangeHomeroomTeacher v-if="isShowModalChangeHomeroomTeacher"
                         :studentsDuo="studentsDuo"
                         :listGVCN="listGVCNDuo"
                         :isShow="isShowModalChangeHomeroomTeacher"
                         :filterForm.sync="filterForm"
                         :selected-item="selectedItem"
                         @clear-item-selected="handleClearItemSelected"
                         @close-modal-change-homeroom-teacher="closeModalChangeHomeroomTeacher()"/>
    <ModalChangeUser v-if="isShowModalChangeUser"
                     :studentsDuo="studentsDuo"
                     :listUser="listUser"
                     :isShow="isShowModalChangeUser"
                     :filterForm.sync="filterForm"
                     @close-modal-change-homeroom-teacher="closeModalChangeUser()"/>
  </div>
</template>
<script>
import checkPermission from '@/modules/student_care/mixins/checkPermission';
import { mapActions, mapState } from 'vuex';
import RepositoryFactory from '@/services/RepositoryFactory';
import { PERMISSION_TO_ACTION } from '@/modules/duo_care/constant';
import { setPageTitle } from '@/helpers/utils';
import StudentCareServices from '../../../services/StudentCareServices';
import CardFilterForm from './CardFilterForm.vue';
import ModalChangeHomeroomTeacher from './ModalChangeHomeroomTeacher.vue';
import ModalChangeUser from './ModalChangeUser.vue';

const ContactRepository = RepositoryFactory.get('contact');

const DUO_TAB_NAME = {
  0: 'Chăm sóc định kì',
  1: 'Gia hạn - Upsale',
  2: 'Kho Chung',
};

export default {
  components: {
    CardFilterForm,
    ModalChangeHomeroomTeacher,
    ModalChangeUser,
  },
  mixins: [checkPermission],
  props: {
    selectedItem: {
      type: Array,
      default: () => ([]),
    },
    filterForm: {
      type: Object,
      default: () => ({}),
    },
    totalItem: {
      type: Number,
      default: 0,
    },
    studentsDuo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isCloseOnClick: true,
      limitOptions: [10, 20, 50, 100, 200, 500],
      tab: 0,
      actionList: [
        // {
        //   title: 'Cập nhật người phụ trách',
        //   type: 'change_user',
        // },
      ],
      isShowModalChangeUser: false,
      isShowModalChangeHomeroomTeacher: false,
      listUser: [],
    };
  },
  async created() {
    if (this.$route.query.tab === undefined) {
      await this.$router.push({
        query: {
          typeCurriculum: 'duo',
          tab: this.tab,
        },
      });
    }
    setPageTitle(`DUO - ${DUO_TAB_NAME[this.tab]}`);
    this.getListUser();
    this.getListGVCNDuo();
  },
  mounted() {
    if (this.$route.query.tab !== undefined) {
      this.tab = +this.$route.query.tab;
      if (this.tab === 0) {
        this.changeTab(1, 0);
      }
      if (this.tab === 1) {
        this.changeTab(2, 0);
      }
      if (this.tab === 2) {
        this.changeTab(1, 1);
      }
    }
  },
  watch: {
    tab: {
      handler(val) {
        setPageTitle(`DUO - ${DUO_TAB_NAME[val]}`);
        this.actionList = [];
        let tabAction = [];
        // if (this.checkPermission('change-homeroom-teacher_read')) {
        //   this.actionList.push({
        //     title: 'Chuyển quản lý học tập',
        //     type: 'change_homeroom_teacher',
        //   });
        // }
        // if (this.checkPermission('early-extend_read')) {
        //   this.actionList.push({
        //     title: 'Gia hạn sớm',
        //     type: 'move_to_early_extension',
        //   });
        // }
        if (val === 0) {
          tabAction = PERMISSION_TO_ACTION.PERIODICALLY_CARE;
        } else if (val === 1) {
          tabAction = PERMISSION_TO_ACTION.EXTEND;
        } else if (val === 2) {
          tabAction = PERMISSION_TO_ACTION.GENERAL_TAB;
        }
        tabAction.forEach((e) => {
          if (this.checkPermission(e.permission)) {
            this.actionList.push({
              title: e.title,
              type: e.type,
            });
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('duo_care', ['getListGVCNDuo']),
    changeCloseOnClick(val) {
      this.isCloseOnClick = val;
    },
    async moveContactToGeneralTab(body, type) {
      this.appLoadingData(true, 0);
      const res = await StudentCareServices.moveToGeneralTab({
        routineStudentIdList: body.map((e) => e.id),
        moveToKhoChung: type === 1 ? 1 : null,
        moveToCsdk: type === 2 ? 1 : null,
      });
      this.appLoadingData(false, 0);
      if (res?.success) {
        this.$emit('clear-item-selected');
        this.$swal({
          type: 'success',
          title: 'Thành công!',
          text: `${type === 1 ? 'Chuyển học viên sang tab kho chung thành công' : 'Chuyển học viên sang CSĐK thành công'}`,
          timer: 2000,
        }).then(() => {
          this.filterForm.callIds = [];
          this.filterForm.callStatusIds = [];
          Bus.$emit('duo-care-list-filter');
        });
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res?.message || `Có lỗi khi chuyển vào ${type === 1 ? 'Kho chung' : 'Chăm sóc định kì'}!`,
        });
      }
    },
    handleClearItemSelected() {
      this.$emit('clear-item-selected');
    },
    checkRole(role) {
      // return true;
      return this.$store.state.permissions.some((e) => e === role);
    },
    applyPendingPage: _.debounce(function () {
      if (+this.filterForm.pendingPage < 1) this.filterForm.pendingPage = 1;
      this.filterForm.page = parseInt(this.filterForm.pendingPage, 10);
      Bus.$emit('duo-care-list-no-count-filter');
    }, 1000),
    searchRecords() {
      this.$emit('clear-item-selected');
      Bus.$emit('duo-care-list-filter');
    },
    changeTab(typeCustomerCare, isDuoGenenalTab, isTabClick = false) {
      this.filterForm.is_duo_general_tab = isDuoGenenalTab;
      this.filterForm.typeCustomerCare = typeCustomerCare;
      this.filterForm.callIds = [];
      this.filterForm.callStatusIds = [];
      this.filterForm.homeroomTeacherIds = [];
      this.filterForm.userIds = [];
      this.filterForm.productIds = [];
      this.filterForm.courseEndDates = [];
      this.$emit('change-tab');
      Bus.$emit('duo-care-list-filter', true);
      if (isTabClick) {
        this.$nextTick(() => {
          this.$router.push({
            query: {
              typeCurriculum: 'duo',
              tab: this.tab,
            },
          });
        });
      }
    },
    showModalAction(modalType) {
      // const itemsSelected = this.studentsDuo.filter((item) => item.checkbox);
      if (!this.selectedItem?.length) {
        this.$swal({
          title: 'Lỗi!',
          text: 'Vui lòng chọn khách hàng !!!',
        });
        return;
      }
      if (modalType === 'change_homeroom_teacher') {
        this.isShowModalChangeHomeroomTeacher = true;
        return;
      }
      if (modalType === 'change_user') {
        this.isShowModalChangeUser = true;
        return;
      }
      if (modalType === 'move_to_early_extension') {
        this.moveToEarlyExtension(this.selectedItem);
      }
      if (modalType === 'move_to_general_tab') {
        this.moveContactToGeneralTab(this.selectedItem, 1);
      }
      if (modalType === 'move_to_periodically_care_tab') {
        this.moveContactToGeneralTab(this.selectedItem, 2);
      }
    },
    closeModalChangeHomeroomTeacher() {
      this.isShowModalChangeHomeroomTeacher = false;
    },
    closeModalChangeUser() {
      this.isShowModalChangeUser = false;
    },
    async moveToEarlyExtension(body) {
      this.appLoadingData(true, 0);
      const res = await StudentCareServices.moveToExtend({
        routineStudentIdList: body.map((e) => e.id),
        typeCustomerCare: this.filterForm.typeCustomerCare,
      });
      this.appLoadingData(false, 0);
      if (res?.success) {
        this.$emit('clear-item-selected');
        this.$swal({
          type: 'success',
          title: 'Thành công!',
          text: 'Chuyển gia hạn sớm thành công!',
          timer: 2000,
        }).then(() => {
          this.filterForm.callIds = [];
          this.filterForm.callStatusIds = [];
          Bus.$emit('duo-care-list-filter');
        });
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res?.message || 'Có lỗi khi chuyển gia hạn sớm!',
        });
      }
    },
    async getListUser() {
      const res = await ContactRepository.getListUserV2();
      if (res?.success) {
        const personInCharges = [];
        // eslint-disable-next-line no-unused-expressions
        res?.data.forEach((ministry) => {
          const { users = [] } = ministry;
          if (users.length) {
            personInCharges.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach((user) => {
              personInCharges.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.listUser = personInCharges;
      }
    },
    async nextPage() {
      this.filterForm.page = parseInt(this.filterForm.page, 10) + 1;
      this.filterForm.pendingPage = parseInt(this.filterForm.pendingPage, 10) + 1;
      Bus.$emit('duo-care-list-no-count-filter');
    },
    async previousPage() {
      this.filterForm.page = parseInt(this.filterForm.page, 10) - 1;
      this.filterForm.pendingPage = parseInt(this.filterForm.pendingPage, 10) - 1;
      Bus.$emit('duo-care-list-no-count-filter');
    },
    showIndex() {
      if (this.totalItem > 0) {
        const maxIndex = this.totalItem < this.filterForm.limit ? parseInt(this.filterForm.page - 1, 10) * parseInt(this.filterForm.limit, 10) + this.totalItem : parseInt(this.filterForm.page, 10) * parseInt(this.filterForm.limit, 10);
        return this.totalItem < this.filterForm.limit ? `${maxIndex - parseInt(this.totalItem, 10) + 1} - ${maxIndex}` : `${maxIndex - parseInt(this.filterForm.limit, 10) + 1} - ${maxIndex}`;
      }
      return ('0 - 0');
    },
  },
  computed: {
    ...mapState('duo_care', ['listGVCNDuo']),
  },
};
</script>

<style lang="css" scoped>
.top-bar {
  min-height: 46px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  padding: 0px 15px 0px 15px;
  display: flex;
  justify-content: space-between;
}
.second-bar {
  margin-top: 15px;
  min-height: 39px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
}

.quick-filter-action {
  min-height: 39px;
  border-radius: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 13px;
  margin-right: 1px;
  cursor: pointer;
}

.button-create {
  background-color: #e91e63 !important;
  border-color: #e91e63 !important;
}

.group-btn-search {
  height: 30px;
  min-width: 80px;
  background: #E91E63;
  border-radius: 3px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  padding: 9px;
  margin-left: 20px;
  cursor: pointer;
}

.search-form {
  min-width: 250px;
  height: 22px;
  display: flex;
  justify-content: flex-start;
  padding-top: 9px;
}

.group-action-button {
  padding-top: 9px;
}
#duo-care-list .search-text-field {
  margin-top: -10px !important;
}
.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
/deep/ .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot > input::placeholder {
  font-size: 11px !important;
}
</style>
